import React, { createContext, useContext, useState, useEffect } from 'react';
import { API } from '../api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check for tokens in localStorage on init
    const checkAuth = async () => {
      const accessToken = localStorage.getItem('accessToken');
      const refreshToken = localStorage.getItem('refreshToken');
      const storedUser = localStorage.getItem('user');

      if (accessToken && storedUser) {
        setUser(JSON.parse(storedUser));
        setIsAuthenticated(true);
        // Ideally we would validate token here
      } else if (refreshToken) {
        // Try to refresh
        try {
          const result = await API.auth.refreshToken(refreshToken);
          if (result.success) {
            const newAccessToken = result.data.accessToken || result.data.access_token || result.data.token;
            if (newAccessToken) {
              localStorage.setItem('accessToken', newAccessToken);
            }
            if (storedUser) setUser(JSON.parse(storedUser));
            setIsAuthenticated(true);
          } else {
            // Invalid refresh token
            logout();
          }
        } catch (error) {
          logout();
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const login = async (username, password) => {
    try {
      const result = await API.auth.login(username, password);
      if (result.success) {
        // Handle different casing (camelCase vs snake_case)
        const accessToken = result.data.accessToken || result.data.access_token || result.data.token;
        const refreshToken = result.data.refreshToken || result.data.refresh_token;
        const user = result.data.user;

        if (accessToken) {
          localStorage.setItem('accessToken', accessToken);
        }
        if (refreshToken) {
          localStorage.setItem('refreshToken', refreshToken);
        }
        if (user) {
          localStorage.setItem('user', JSON.stringify(user));
          setUser(user);
        }
        
        setIsAuthenticated(true);
        return { success: true };
      }
      return result;
    } catch (error) {
      return { success: false, error: 'Ошибка входа' };
    }
  };

  const logout = async () => {
    try {
      await API.auth.logout();
    } finally {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      setUser(null);
      setIsAuthenticated(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
